"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.strictEqual = function (a) { return function (b) { return a === b; }; };
exports.setoidString = { equals: exports.strictEqual };
exports.setoidNumber = { equals: exports.strictEqual };
exports.setoidBoolean = { equals: exports.strictEqual };
exports.getArraySetoid = function (S) { return ({
    equals: function (xs) { return function (ys) { return xs.length === ys.length && xs.every(function (x, i) { return S.equals(x)(ys[i]); }); }; }
}); };
//# sourceMappingURL=Setoid.js.map